//ページ遷移後でもアンカーポイントがあればスムーススクロール
window.onload = function() {
	//現在のページURLのハッシュ部分を取得
	const hash = location.hash;
	//ハッシュ部分がある場合の条件分岐
	if(hash){
		//ページ遷移後のスクロール位置指定
		$("html, body").stop().scrollTop(0);
		//処理を遅らせる
		setTimeout(function(){
			//リンク先を取得
			const target = $(hash);
			//リンク先までの距離を取得(PC/SPで分岐)
            if(window.matchMedia('(min-width:769px)').matches){
              console.log('ウィンドウサイズは768より大きいです。');
              position = target.offset().top;
            } else {
              console.log('ウィンドウサイズは768以下です。');
              position = target.offset().top - 130;
            }
            console.log(target.offset().top);
            console.log(position);
			//指定の場所までスムーススクロール
			$("html, body").animate({scrollTop:position}, 500, "swing");
		});
	}
}

//カートページの数量スピナーボタン（plus）
$('.spinner-up').on('click', function () {
  let current_qty = parseInt($(this).prevAll('input').val());
  //alert(current_qty);
  let change_qty = current_qty + 1;
  //alert( change_qty);
  $(this).prevAll('input').attr("value", change_qty);
  $(this).prevAll('input').trigger('cahge');
});
//カートページの数量スピナーボタン（minus）
$('.spinner-down').on('click', function () {
  let current_qty = parseInt($(this).nextAll('input').val());
  //alert(current_qty);
  let change_qty = current_qty - 1;
  //alert( change_qty);
  $(this).nextAll('input').attr("value", change_qty);
  $(this).nextAll('input').trigger('cahge');
});

//カートページにカスタマイズの画面でアプリ追加した際に、備考欄に隣接して表示されるようにする
// $('.shopify-app-block').clone(true).appendTo("#cart_app_block");
$(document).ready(function () {
  const targetElement = $("#cart-delivery-datetime_section_os2");
  const destination = $("#cart_app_block");

  if (targetElement.length && destination.length) {
    targetElement.appendTo(destination);
    console.log("#cart-delivery-datetime_section_os2 を #cart_app_block 内に移動しました");
  } else {
    console.error("対象の要素が見つかりません");
  }
});


//SPドロワーメニュー内のカテゴリーアコーディオンナビを初期から展開状態に（ドロワータップ時にトリガー）
$('.site-header-menu-toggle').on('click', function () {
  $('ul.navmenu.navmenu-depth-1>li>button').trigger('click');
  $('ul.navmenu.navmenu-depth-2>li>button').trigger('click');
});

//商品ページのAll in Giftでギフト配送をチェックしているときに通常のフォームを非表示にする
document.addEventListener('webkitAnimationStart', function (event) {
  if (event.animationName == 'elementInserted') {
    $('.product-block--form').hide();
  }
}, true);

document.addEventListener('webkitAnimationStart', function (event) {
  if (event.animationName == 'elementInserted_off') {
    $('.product-block--form').show();
  }
}, true);

//定期購買の注文履歴を表示しているかどうかの判定
function ifSubscription() {
  location.href = '/account?hbSubscriptionPath=%2F';
}

//footerのソーシャルアイコンを下に表示
$(function () {
  // conleObj1クラスの要素をクローン
  let clone = $(".social-icons").clone();
  $(".site-footer-item.footer_bottom").prepend(clone);
});

//カートに入れるボタンを押したときのアニメーション
$('button.product-form--atc-button').on('click', function () {
  console.log('ok');
  $('.add_cartbutoon_animation').addClass('animated01').addClass('animated02');
});

document.addEventListener('DOMContentLoaded', () => {
  // 既存のイベントリスナーを削除
  document.querySelectorAll('[data-btnspinner]').forEach(button => {
    button.replaceWith(button.cloneNode(true));
  });

  const updateButtonState = (button, currentQuantity) => {
    const inventoryQuantity = parseInt(button.dataset.inventoryQuantity, 10);
    const inventoryPolicy = button.dataset.inventoryPolicy;
    
    // 在庫管理している場合のみ制御
    if (inventoryPolicy === 'deny' && !isNaN(inventoryQuantity)) {
      if (currentQuantity >= inventoryQuantity) {
        button.style.opacity = '0.1';
        button.style.cursor = 'unset';
        button.disabled = true;
      } else {
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
        button.disabled = false;
      }
    }
  };

  // ページ読み込み時に各ボタンの状態を初期化
  document.querySelectorAll('[data-btnspinner="up"]').forEach(button => {
    const wrapper = button.closest('[data-quantity-wrapper]');
    const input = wrapper.querySelector('[data-quantity-input]');
    const currentValue = parseInt(input.value, 10);
    updateButtonState(button, currentValue);
  });

  const handleQuantityChange = async (button) => {
    if (button.dataset.processing === 'true' || button.disabled) return;
    
    try {
      button.dataset.processing = 'true';
      button.style.opacity = button.disabled ? '0.1' : '0.5';
      
      const wrapper = button.closest('[data-quantity-wrapper]');
      const input = wrapper.querySelector('[data-quantity-input]');
      const currentValue = parseInt(input.value, 10);
      const itemKey = input.id.replace('updates_', '');
      
      let newValue = currentValue;
      if (button.dataset.btnspinner === 'up') {
        const inventoryQuantity = parseInt(button.dataset.inventoryQuantity, 10);
        const inventoryPolicy = button.dataset.inventoryPolicy;
        
        if (inventoryPolicy === 'deny' && !isNaN(inventoryQuantity)) {
          if (currentValue >= inventoryQuantity) {
            button.style.opacity = '0.1';
            button.style.cursor = 'unset';
            button.disabled = true;
            button.dataset.processing = 'false';
            return;
          }
          newValue = Math.min(currentValue + 1, inventoryQuantity);
        } else {
          newValue = currentValue + 1;
        }
      } else if (button.dataset.btnspinner === 'down' && currentValue > 1) {
        newValue = currentValue - 1;
        
        // 減らした後、増やすボタンの状態をチェック
        const upButton = wrapper.querySelector('[data-btnspinner="up"]');
        if (upButton) {
          const inventoryQuantity = parseInt(upButton.dataset.inventoryQuantity, 10);
          if (newValue < inventoryQuantity) {
            upButton.style.opacity = '1';
            upButton.style.cursor = 'pointer';
            upButton.disabled = false;
          }
        }
      }

      if (newValue === currentValue) {
        button.dataset.processing = 'false';
        button.style.opacity = button.disabled ? '0.1' : '1';
        return;
      }

      input.value = newValue;

      // カートの更新処理
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newValue
        })
      });

      if (!response.ok) throw new Error('Cart update failed');

      // カートの自動更新をトリガー
      window.location.reload();

    } catch (error) {
      console.error('Error updating cart:', error);
      input.value = currentValue;
      const upButton = wrapper.querySelector('[data-btnspinner="up"]');
      if (upButton) {
        updateButtonState(upButton, currentValue);
      }
    }
  };

  // スピナーボタンのクリックイベントを新しく設定
  document.querySelectorAll('[data-btnspinner]').forEach(button => {
    button.addEventListener('click', () => handleQuantityChange(button), { once: true });
  });

  // カート要素の監視を設定
  const cartContainer = document.querySelector('.cart-form');
  if (cartContainer) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(async (node) => {
            if (node.nodeType === 1 && (
              node.classList.contains('cart-item--discount-price') ||
              node.querySelector('.cart-item--discount-price')
            )) {
              try {
                const response = await fetch('/cart.js');
                if (!response.ok) throw new Error('Failed to fetch cart data');
                const cartData = await response.json();
                updateCartTotals(cartData);
              } catch (error) {
                console.error('Error updating cart after discount price appeared:', error);
              }
            }
          });
        }
      });
    });

    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }
});
